import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const SignUpConfirmationPage = lazy(() => import('./SignUpConfirmationPage'));

const SignUpConfirmationConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'sign-up-confirm',
      element: <SignUpConfirmationPage />,
    },
  ],
};

export default SignUpConfirmationConfig;
